import { Injector, Component, OnInit, ViewChild, OnDestroy, inject } from "@angular/core";
import { Router } from "@angular/router";
import { NgbCalendar, NgbDate, NgbDateParserFormatter } from "@ng-bootstrap/ng-bootstrap";
import { ConfirmationService, MessageService } from "primeng/api";
import { Subscription } from "rxjs";


@Component({ template: "" })
export class ListBaseComponent implements OnInit {

  //DatePicker variable

  // calendar = inject(NgbCalendar);
  formatter = inject(NgbDateParserFormatter);

  fromDate: NgbDate | null = null;
  toDate

  //Default variable

  public pageTitle = '';
  public pageRoute = '';
  public detailRoute='';
  public dialogTitle='';
  public dataSources: any;
  private _filterParams = '';

  public tableProperties: any[];


  public filterPage = "";
  public paginationCurrentPage: number = 1;
  public dataSize: number;

  public searchText: string = '';
  private _searchFilter: string = '';

  public isLoading: boolean;
  public isShowDialog: boolean = false;

  public model:any; 
  public modelId: any = null

  protected serviceBase: any;


  private _router: Router;
  private _confirmationService: ConfirmationService;
  private _messageService: MessageService;



  constructor(public injector: Injector) {
    this._router = this.injector.get(Router);
    this._confirmationService = this.injector.get(ConfirmationService);
    this._messageService = this.injector.get(MessageService);

  }



  ngOnInit(): void {

    // this.loadData(this.filterPage);
    this.loadData();
  }


  onReceiveFromDate(newFromData: NgbDate | null) {
    this.fromDate = newFromData;
  }

  onReceiveToDate(newToDate: NgbDate | null) {
    this.toDate = newToDate;
  }

  callSearchDataToChilComponent() {
    this.searchData();    // Vous pouvez ajouter du code ici pour réagir à l'appel du composant enfant.
  }

  updateParentVariable(newValue: boolean) {
    this.isShowDialog=newValue;
    // this.loadData(this.filterPage);
    this.loadData()
  }


  //Class qui gérer les recherche et pagination
  loadData(){
    this.serviceBase.getAll().subscribe(resultData => {
      this.dataSources = resultData
      this.isLoading = true;
      console.log(this.dataSources)

    });
  }

  // loadData(filter: string) {

  //   if (this.pageTitle != 'MATRICULE') {
  //     this.serviceBase.getAll(filter).subscribe(resultData => {
  //       this.dataSources = resultData
  //       this.isLoading = true;
  //       console.log(this.dataSources)

  //     });

  //   } else {
  //     this.serviceBase.getImages(filter).subscribe(resultData => {
  //       this.dataSources = resultData;
  //       this.isLoading = true;

  //       console.log("DataSource ", this.dataSources)

  //     });

  //   }

  // }



  searchData() {
    this._filterParams = this.filterPage;

    if (this.searchText.trim() !== '') {
      if (this.pageTitle == 'BUY' || this.pageTitle == 'RENT') {
        this._searchFilter = `searchClient=${this.searchText}&`;

        this._filterParams += this._searchFilter;
      }
      else if (this.pageTitle == 'MATRICULE') {
        this._searchFilter = `name=${this.searchText}&`;

        this._filterParams += this._searchFilter;

      }
      else {
        this._searchFilter = `searchTerm=${this.searchText}&`;
        this._filterParams += this._searchFilter;
      }
    }

    // Ajoutez la logique nécessaire pour le filtre de pagination
    this._filterParams += `page=${this.paginationCurrentPage}&`;

    // Ajoutez la logique nécessaire pour les filtres de date
    if (this.fromDate) {
      const startDateFilter = `startDate=${this.formatter.format(this.fromDate)}&`;
      this._filterParams += startDateFilter;
    }

    if (this.toDate) {
      const endDateFilter = `endDate=${this.formatter.format(this.toDate)}&`;
      this._filterParams += endDateFilter;
    }

    // this.loadData(this._filterParams);
    this.loadData()
  }

  movePagination(element: string) {
    if (element === 'next') {
      this.paginationCurrentPage += 1;
    } else if (element === 'prev') {
      this.paginationCurrentPage -= 1;
    }

    this._filterParams = `${this.filterPage}page=${this.paginationCurrentPage}&`;

    if (this._searchFilter) {
      this._filterParams += this._searchFilter;
    }

    // Ajouter la logique nécessaire pour le filtre de dates uniquement si les dates ne sont pas null
    if (this.fromDate) {
      const startDateFilter = `startDate=${this.formatter.format(this.fromDate)}&`;
      this._filterParams += startDateFilter;
    }

    if (this.toDate) {
      const endDateFilter = `endDate=${this.formatter.format(this.toDate)}&`;
      this._filterParams += endDateFilter;
    }

    // this.loadData(this._filterParams);
  }
  //Endddddd




  refreshData() {
    console.log('refresh Data')
    // this.loadData("");
    this.loadData();
  }



  //Class qui va gérer les modals et autres
  changeStatusModel(model: any, deletePropertyName: string, modelElement: any) {
    this._confirmationService.confirm({
      message: 'Voulez-vous changer ' + deletePropertyName + ' ' + modelElement + '?',
      header: 'Confirmation de la suspension',
      icon: 'pi pi-exclamation-triangle',
      acceptLabel: 'Oui',
      rejectLabel: 'Non',
      acceptButtonStyleClass: '',
      rejectButtonStyleClass: '',
      accept: () => {
        this.serviceBase.update(model._id ? model._id : model.id, model).subscribe((result) => {
          // this.loadData("");
          this.loadData()
          this._messageService.add({ severity: 'success', summary: 'Successful', detail: deletePropertyName + ' changé avec succes', life: 3000 });
        })
      }
    });
  }


  deleteData(modelId: any, deletePropertyName: string, modelElement: any) {

    this._confirmationService.confirm({
      message: 'Etes-vous sur de vouloir supprimer ' + deletePropertyName + ' ' + modelElement + '?',
      header: 'Confirmation de suppression',
      icon: 'pi pi-exclamation-triangle',
      acceptLabel: 'Oui',
      rejectLabel: 'Non',
      acceptButtonStyleClass: '',
      rejectButtonStyleClass: '',
      accept: () => {
        if (this.pageTitle != 'MATRICULE') {
          this.serviceBase.delete(modelId).subscribe((result) => {
            // this.loadData("");
            this.loadData()
            this._messageService.add({ severity: 'success', summary: 'Successful', detail: deletePropertyName + ' supprime avec succes', life: 3000 });
          })
        } else {
          this.serviceBase.deleteImage(modelId).subscribe((result) => {
            // this.loadData("");
            this.loadData();
            this._messageService.add({ severity: 'success', summary: 'Successful', detail: deletePropertyName + ' supprime avec succes', life: 3000 });
          })
        }

      }
    });

  }
  //end...

  //Class qi va gérer les changements de route autres
  openAddForm() {
    this._router.navigate([this.pageRoute]);
  }

   //Class qi va gérer les changements de route autres
   openDetailPage(id:any) {
    console.log(id)
    this._router.navigate([this.detailRoute,id]);
  }


  openUpdateForm(model: any) {
    const entityId = model?._id ? model._id : model?.id;
    this._router.navigate([`${this.pageRoute}/${entityId}`], { state: { model } });
  }

  openDialogForm(modelElement?:any) {
    this.model={};

    this.isShowDialog = true;
    if(modelElement){
      this.dialogTitle="Modifier"
      this.model=modelElement;
    }

  }

  
  //end




  //DatePicker element
  //Class qui va gérer cette partie pour le date picker

  onDateSelection(date: NgbDate) {
    if (!this.fromDate && !this.toDate) {
      this.fromDate = date;
    } else if (this.fromDate && !this.toDate && date && date.after(this.fromDate)) {
      this.toDate = date;
      this.searchData();
      console.log("huile")
    } else {
      this.toDate = null;
      this.fromDate = date;
    }
  }


}
